module.exports = __webpack_public_path__ + "img/icon_company.9dfb737a.svg";